<template>
  <div>
    <header class="vff-header">
      <div class="f-container">
        <a href="http://toclog.com.br" target="_blank">
          <img id="logo" src="@/assets/logo.png" />
        </a>
      </div>
    </header>

    <flow-form
      ref="flowform"
      v-on:complete="onComplete"
      v-bind:questions="questions"
      v-bind:language="language"
      v-bind:progressbar="false"
      v-bind:standalone="true"
      v-bind:navigation="false"
      v-bind:hyerNavitation="true"
    >
      <template v-slot:complete>
        <div class="f-section-wrap">
          <div>
            <div v-if="loading">
              <span class="fh2"
                >⏳👩‍💻 Registrando a sua coleta no nosso sistema...</span
              >
              <br />
              <br />
              <p>
                Por favor aguarde, esse processo pode demorar até
                <b>10 segundos</b>.
              </p>
            </div>

            <div v-else>
              <div v-if="error">
                <span class="fh2">
                  ❌ Houve um erro ao tentar registrar a sua coleta: <span class="erro-ssw">{{ errorMessage }}</span>
                </span>

                <span class="f-answered">
                  Entraremos em contato o mais breve possível através do seu
                  WhatsApp.
                </span>

                <p class="f-answered">
                  Em caso de urgência, esse é o número do nosso suporte de
                  coletas:
                  <a
                    href="https://api.whatsapp.com/send?phone=556291724136&text=Ol%C3%A1!%20Preciso%20de%20ajuda%20com%20a%20coleta%20que%20acabei%20de%20solicitar%20no%20app"
                    target="_blank"
                    >Abrir WhatsApp</a
                  >
                </p>
              </div>

              <div v-else>
                <span class="fh2">Pedido de coleta registrado 🎉✅ </span>
                <p class="coleta">
                  O número da sua coleta é:
                  <span class="coleta-number">{{ getColetaNumber() }}</span>
                </p>
                <p class="f-description">
                  <span
                    >Obrigado por utilizar nosso novo app de coleta e até a
                    próxima! 😊
                  </span>
                </p>

                <p>
                  Se precisar entrar em contato, manda um zap! Clique aqui para
                  abrir o app:
                  <a
                    href="https://api.whatsapp.com/send?phone=556291724136&text=Ol%C3%A1!%20Preciso%20de%20conversar%20sobre%20meu%20pedido%20de%20coleta"
                    target="_blank"
                    >Abrir WhatsApp</a
                  >
                </p>
                <br />
                <p>
                  Para solicitar uma outra coleta clique no link 👉
                  <a href="/">Nova coleta</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:completeButton>
        <div class="f-submit">
          <!-- Leave empty to hide default submit button -->
        </div>
      </template>
    </flow-form>
  </div>
</template>

<script>
import FlowForm from "hyer-flow-form";

import ptBRLanguageModel from "./components/ptBRLanguageModel";
import questions from "./questions/toclog";
import methods from "./components/methods";

export default {
  name: "coleta-toclog",
  components: {
    FlowForm,
  },
  data() {
    return {
      error: false,
      errorMessage: "",
      loading: false,
      completed: false,
      language: ptBRLanguageModel,
      coletaNumber: "",
      questions,
    };
  },
  methods,
};
</script>

<style lang="css">
@import "~hyer-flow-form/dist/vue-flow-form.css";

@import url(./css/theme.css);
</style>
